import { useTranslation } from 'react-i18next';

import { EditContactDialog } from '@/features/projects/project-details/components/edit-contact-dialog';
import {
  ProjectPropertiesMenuItem,
  ProjectPropertiesMenuItemPrefix,
  ProjectPropertiesMenuItemValue,
} from '@/features/projects/project-details/components/layouts/project-properties-menu-layout';
import { useContactItemLogic } from '@/features/projects/project-details/hooks/use-contact-item-logic';

type ContactItemProps = {
  projectId: number;
  projectType: string;
  projectOrgId: number | null;
  mainContact: string | null;
  contractorContact: string | null;
  clientContact: string | null;
};

export const ContactItem = ({
  projectId,
  projectType,
  projectOrgId,
  mainContact,
  contractorContact,
  clientContact,
}: ContactItemProps) => {
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  const { dialogOpen, setDialogOpen, activeField, handleClick, contactFields } =
    useContactItemLogic({
      projectType,
      projectOrgId,
      mainContact,
      contractorContact,
      clientContact,
    });

  return (
    <>
      {contactFields.map((fieldConfig) => {
        const translationKey = fieldConfig.label as
          | 'main_contact'
          | 'contractor_contact'
          | 'client_contact';
        return (
          <EditContactDialog
            key={fieldConfig.field}
            isOpen={dialogOpen && activeField === fieldConfig.field}
            onClose={() => setDialogOpen(false)}
            projectId={projectId}
            initialContact={fieldConfig.contact}
            field={fieldConfig.field}
            label={t(translationKey)}
          >
            <div>
              <ProjectPropertiesMenuItem
                isEditable={fieldConfig.isEditable}
                onEdit={
                  fieldConfig.isEditable
                    ? () =>
                        handleClick(
                          fieldConfig.field,
                          fieldConfig.contact,
                          t(translationKey),
                        )
                    : undefined
                }
              >
                <ProjectPropertiesMenuItemPrefix>
                  {t(translationKey)}
                </ProjectPropertiesMenuItemPrefix>
                <ProjectPropertiesMenuItemValue>
                  <span>{fieldConfig.contact || t('enter_contact')}</span>
                </ProjectPropertiesMenuItemValue>
              </ProjectPropertiesMenuItem>
            </div>
          </EditContactDialog>
        );
      })}
    </>
  );
};
